export const Comp800_171 = require("./800-171.png")
export const CompCis_200 = require("./cis-200.png")
export const CompPciDss = require("./pci_dss.png")
export const CompSfc = require("./scf.png")
export const BackgroundImage = require("./background.jpg")
